import { NgModule, Optional, SkipSelf } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { TokenInterceptor } from './interceptors/token.interceptor';
import { EncodeHttpParamsInterceptor } from './interceptors/encode-http-params.interceptor';
import { NoCacheInterceptor } from './interceptors/no-cache.interceptor';
import { throwIfAlreadyLoaded } from './module-import.guard';

import { SharedModule } from '@shared/shared.module';
import { AlertModule } from './alert/alert.module';

import { UserService } from './services/user.service';
import { AuthService } from './services/auth.service';
import { ApiService } from './services/api.service';
import { ApiErrorsService } from './services/api-errors.service';
import { DriverCardService } from './services/driver-card.service';
import { SocketService } from './services/socket.service';
import { RemoveCardComponent } from './remove-card/remove-card.component';
import { RemoveDownloadKeyComponent } from './remove-download-key/remove-download-key.component';
import { GoodbyePageModule } from './goodbye-page/goodbye-page.module';

@NgModule({
	declarations: [RemoveCardComponent, RemoveDownloadKeyComponent],
	exports: [AlertModule],
	imports: [
		SharedModule,
		AlertModule,
		GoodbyePageModule
	],
	providers: [
		AuthService,
		UserService,
		ApiService,
		ApiErrorsService,
		SocketService,
		DriverCardService,
		{
			provide: HTTP_INTERCEPTORS,
			useClass: TokenInterceptor,
			multi: true
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: EncodeHttpParamsInterceptor,
			multi: true
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: NoCacheInterceptor,
			multi: true
		}
	]
})
export class CoreModule {
	constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
		throwIfAlreadyLoaded(parentModule, 'CoreModule');
	}
}
